import 'react-multi-carousel/lib/styles.css';

import Carousel from 'react-multi-carousel';

import { PlusCircleOutlined } from '@ant-design/icons';
import { Col, Spin, Typography } from 'antd';

import { Marketplace, Paginator } from 'interfaces/marketplace';

import ItemCard from '../ItemCard';
import NoResults from '../NoResults';
import styles from './styles.module.css';

type ItemCarouselProps = {
  items?: Marketplace[];
  loading?: boolean;
  pagination: Paginator;
  setMobileList: (open: boolean) => void;
  cleanAllFilters: () => void;
  isFallback?: boolean;
};

const { Title } = Typography;

const ItemCarousel = ({
  items,
  loading,
  pagination,
  setMobileList,
  cleanAllFilters,
  isFallback
}: ItemCarouselProps) => {
  const showMoreCard = pagination.totalItems > 8;

  if (loading) {
    return (
      <Col xs={24} md={0}>
        <Spin className={styles.loading} />
      </Col>
    );
  }

  if (!items?.length && !loading) {
    return (
      <Col xs={24} md={0}>
        <NoResults cleanFilters={cleanAllFilters} />
      </Col>
    );
  }

  return (
    <Col xs={24} md={0}>
      {isFallback && (
        <Title level={5} className={styles.sectionTitle}>
          Veja todos os eventos disponíveis
        </Title>
      )}
      <Carousel
        responsive={{
          tablet: {
            breakpoint: { min: 464, max: 768 },
            items: 4
          },
          mobile: {
            breakpoint: { min: 0, max: 464 },
            items: 2
          }
        }}
        arrows={false}
        draggable
        infinite={false}
        partialVisible
      >
        {items?.map(item => <ItemCard key={item.id} item={item} showTooltip />)}

        {showMoreCard && (
          <div onClick={() => setMobileList(true)} className={styles.seeMoreCard} key='see-more-carousel'>
            <div className={styles.seeMoreCardBackground}>
              <PlusCircleOutlined className={styles.seeMoreIcon} />
            </div>
            <p className={styles.seeMoreText}>Veja mais eventos</p>
          </div>
        )}
      </Carousel>
    </Col>
  );
};

export default ItemCarousel;
